import { toast } from '@montugroup/design-system';
import type { DefaultError, Mutation, Query } from '@tanstack/react-query';
import { onlineManager } from '@tanstack/react-query';
import type { NetworkError } from './types';
import { StatusCode } from './types';
import { errorLogger, generateErrorMessage } from './utils';

export const ERROR_PAGE_STATUSES = [
  StatusCode.Unauthorised,
  StatusCode.BadRequest,
  StatusCode.Forbidden,
  StatusCode.NotFound
];

export const useErrorHandler = () => {
  const handleErrorAlert = (
    error: DefaultError,
    config: Query<unknown, unknown, unknown> | Mutation<unknown, unknown, unknown>
  ) => {
    const networkError = error as NetworkError;
    // check if the error is handled at component level
    const isErrorHandled = config?.meta?.isErrorHandled;
    // enable error logging
    errorLogger(networkError);

    if (isErrorHandled) {
      return;
    }

    toast.error({
      message: generateErrorMessage(networkError.status, !onlineManager.isOnline())
    });
  };

  const handleErrorPage = (error: DefaultError) => {
    const networkError = error as NetworkError;

    if (ERROR_PAGE_STATUSES.includes(networkError.status)) {
      return true;
    }

    return false;
  };

  return { handleErrorAlert, handleErrorPage };
};
